"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBracketMatchUpdateByQuery = instanceOfBracketMatchUpdateByQuery;
exports.BracketMatchUpdateByQueryFromJSON = BracketMatchUpdateByQueryFromJSON;
exports.BracketMatchUpdateByQueryFromJSONTyped = BracketMatchUpdateByQueryFromJSONTyped;
exports.BracketMatchUpdateByQueryToJSON = BracketMatchUpdateByQueryToJSON;
exports.BracketMatchUpdateByQueryToJSONTyped = BracketMatchUpdateByQueryToJSONTyped;
var BracketMatchQueryParams_1 = require("./BracketMatchQueryParams");
var BracketMatchUpdateCommand_1 = require("./BracketMatchUpdateCommand");
/**
 * Check if a given object implements the BracketMatchUpdateByQuery interface.
 */
function instanceOfBracketMatchUpdateByQuery(value) {
    if (!('query' in value) || value['query'] === undefined)
        return false;
    if (!('update' in value) || value['update'] === undefined)
        return false;
    return true;
}
function BracketMatchUpdateByQueryFromJSON(json) {
    return BracketMatchUpdateByQueryFromJSONTyped(json, false);
}
function BracketMatchUpdateByQueryFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'query': (0, BracketMatchQueryParams_1.BracketMatchQueryParamsFromJSON)(json['query']),
        'update': (0, BracketMatchUpdateCommand_1.BracketMatchUpdateCommandFromJSON)(json['update']),
    };
}
function BracketMatchUpdateByQueryToJSON(json) {
    return BracketMatchUpdateByQueryToJSONTyped(json, false);
}
function BracketMatchUpdateByQueryToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'query': (0, BracketMatchQueryParams_1.BracketMatchQueryParamsToJSON)(value['query']),
        'update': (0, BracketMatchUpdateCommand_1.BracketMatchUpdateCommandToJSON)(value['update']),
    };
}
